import {RestAPI} from "@aws-amplify/api-rest";
import router from '@/router';

/**
 * Wrapper voor API aanroepen die automatisch de token ververst indien nodig.
 */
export async function secureRequest(method, apiName, path, init = {}, caUser) {
  
  // 1. Check of de gebruiker is ingelogd en of de token (bijna) verlopen is
  if (caUser.loggedIn() && caUser.isTokenExpired()) {
    console.log("Token is verlopen, vernieuwen...");
    
    try {
      const refreshInit = {
        body: { 
          refreshToken: caUser.getRefreshToken() 
        }
      };

      //console.log("apiname: " + apiName);
      //console.log("refreshInit: ", refreshInit);
      // We gebruiken de standaard API.post voor de refresh zelf
      const tokenResponse = await RestAPI.post(apiName, "/authentication/RefreshToken", refreshInit);

      //console.log("refreshing response: ", tokenResponse);

      // Update de tokens in je globale state
      caUser.setToken(tokenResponse.token);
      caUser.setRefreshToken(tokenResponse.refreshToken);
      
      console.log("Token succesvol ververst.");
    } catch (err) {
      console.log("Error", err);
      console.error("Refresh mislukt. Sessie is echt verlopen.");
      caUser.logout();
      router.push("/sign-in?ontheside=sessionTimedOut");
      throw err;
    }
  }

  // 2. Bouw de headers op (de 'echte' code die je vroeg)
  // We zorgen dat we init.headers niet slopen als die al bestaat
  init.headers = {
    ...init.headers,
    'Authorization': `Bearer ${caUser.getToken()}`
  };

  // 3. Voer de gevraagde methode uit (get, post, put, delete)
  const methodName = method.toLowerCase();
  return await RestAPI[methodName](apiName, path, init);
}